// chats tab
const highlightedOngoingChats = state =>
  state.ongoingChats?.filter(channel => channel.highlight)

const ongoingChatsWithoutHighlight = state =>
  state.ongoingChats?.filter(channel => !channel.highlight)

const ongoingChatsCount = state => state.ongoingChats?.length

// channels tab
const highlightedActiveChannels = state =>
  state.activeChannels?.filter(channel => channel.highlight)

const activeChannelsWithoutHighlight = state =>
  state.activeChannels?.filter(channel => !channel.highlight)

const activeChannelsCount = state => state.activeChannels?.length

const highlightedMentionChannels = state =>
  state.mentionChannels?.filter(channel => channel.highlight)

const mentionChannelsWithoutHighlight = state =>
  state.mentionChannels?.filter(channel => !channel.highlight)

const mentionChannelsCount = state => state.mentionChannels?.length

const followUpChannelCount = (state, getters, rootState, rootGetters) =>
  rootGetters['channel/staff/loggedStaffCounters']?.fupChannels?.unreadMessages

export default {
  highlightedOngoingChats,
  ongoingChatsWithoutHighlight,
  ongoingChatsCount,
  highlightedActiveChannels,
  activeChannelsWithoutHighlight,
  activeChannelsCount,
  highlightedMentionChannels,
  mentionChannelsWithoutHighlight,
  mentionChannelsCount,
  followUpChannelCount
}
